import {
  shadowCamNameForInstance,
  type GameInstanceSessionRecord,
} from '../game-instance/GameInstanceStore';

/**
 * The always-on base/desktop stream camera — the single host-side switch point
 * for the coordinated base-camera rename (android multi-instance Phase 5).
 *
 * Mirrors C++ `Constants::BASE_STREAM_CAMERA`
 * (`apps/playjector/src/PlayJectorLib/include/Constants.h`): both sides MUST
 * flip in the same release or the base stream goes black. `ShadowCam00` is
 * reserved for the base stream; per-instance game cameras take
 * `ShadowCam{k+1:02d}` via `shadowCamNameForInstance` (see GameInstanceStore).
 */
export const BASE_STREAM_CAMERA = 'ShadowCam00';

/**
 * Resolve the camera one game instance's capture must use (android
 * multi-instance host Phase 5 contract): the `instanceLaunched` shadowCamName
 * echo persisted on the record is the truth when present; otherwise the
 * derived name from the frozen naming contract (`ShadowCam{k+1:02d}`) — only a
 * pre-echo placeholder.
 */
export const resolveInstanceCamera = (instance: GameInstanceSessionRecord): string =>
  instance.shadowCamName ?? shadowCamNameForInstance(instance.gameInstanceIndex);
